import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=6accb7da&scoped=true&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accb7da",
  null
  
)

export default component.exports